module.exports = __webpack_public_path__ + "img/SWP_Hammer_1H_01 (2).dea8c98d.png";